import { render, staticRenderFns } from "./open-banking-transfer.vue?vue&type=template&id=b64732ea&scoped=true"
import script from "./open-banking-transfer.vue?vue&type=script&lang=js"
export * from "./open-banking-transfer.vue?vue&type=script&lang=js"
import style0 from "./open-banking-transfer.vue?vue&type=style&index=0&id=b64732ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64732ea",
  null
  
)

export default component.exports